import { isNonEmptyString } from '@/utils/checks'

const excludedDisorders = [
  'Co-Occurring Disorders',
  'Co-Occurring Mental Health',
  'Co-Occurring Substance Use'
]
export const filterOutSpecializationsByCooccuringDisorders = (
  specializations: string[],
  coOccurringDisorder?: string
): string[] => {
  if (!isNonEmptyString(coOccurringDisorder)) return specializations
  return specializations.filter((spec) => !excludedDisorders.includes(spec))
}
